export default __webpack_public_path__ + "static/media/arrow.a4866b8d.svg";